// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8d4a4c21","239":"f69ca495","339":"e04eddc6","455":"bcd31fce"}[chunkId] + ".chunk.js";
};